import React, { useState, type FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import { Button, Space, Text } from '@g2u/ui-kit';

import { useTechTickets } from '../hooks/useTechTickets';
import { CreateTicketModal, TicketList } from 'components';
import styles from '../edit.module.scss';
import { Select } from 'antd';

export namespace TechnicianTickets {
  export type Props = Readonly<{
    technicianId?: string;
  }>;

  export const $: FC<Props> = (props) => {
    const navigate = useNavigate();
    const { technicianId } = props;
    const [status, setStatus] = useState<'0' | '1' | null>(null);
    const { tickets, paginationMetadata, isTicketsLoading } = useTechTickets(status, technicianId);
    const [isCreateModalOpen, setCreateModalOpen] = useState<boolean>();

    return (
      <>
        <Helmet>
          <title>Technician Tickets</title>
        </Helmet>
        <Space.$
          direction={Space.Direction.Vertical}
          size={Space.Size.ExtraLarge}
          fullWidth
          className={styles.edit__content}
        >
          <Space.$ justify={Space.Justify.SpaceBetween}>
            <span>
              <Text.$>Status : </Text.$>
              <Select
                style={{ width: 150 }}
                defaultValue={null}
                options={[
                  {
                    label: 'All',
                    value: null,
                  },
                  {
                    label: 'Open',
                    value: '1',
                  },
                  {
                    label: 'Closed',
                    value: '0',
                  },
                ]}
                onChange={(val) => setStatus(val)}
              />
            </span>
          </Space.$>
          <TicketList.$
            tickets={tickets}
            paginationMetadata={paginationMetadata}
            isLoading={isTicketsLoading}
            onAdd={() => setCreateModalOpen(true)}
            hideColumns={['technician']}
            footer={
              <Button.$
                dataTestId="open-all-tickets"
                onClick={() => navigate(`/tasks/tickets?search_type=technician_id&search_value=${technicianId}&status=${status || ''}`)}
              >
                Open all
              </Button.$>
            }
          />
        </Space.$>
        <CreateTicketModal.$
          technicianId={technicianId}
          isOpen={!!isCreateModalOpen}
          onClose={() => setCreateModalOpen(false)}
        />
      </>
    );
  };
}
